<!-- VuMeter.vue -->
<template>
  <div class="assistent">
    <div class="assistent-photo">
      <img
        :style="borderCss"
        src="@/assets/images/luiz.png" />
    </div>
    <div class="bars">
      <div
        v-for="(bar, index) in barsCss"
        :key="index"
        :style="bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntervoiceSpeaker',
  props: {
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    borderCss () {
      return {
        boxShadow: this.level ? `0 0 10px ${this.level * 10}px rgba(255, 255, 255, 0.3)` : 'none'
      }
    },
    barsCss () {
      const bars = []
      const map = [
        0.2,
        0.6,
        1,
        0.6,
        0.2
      ]
      const minHeight = 10
      const maxHeight = 40
      const diff = maxHeight - minHeight
      for (let i = 0; i < 5; i++) {
        bars.push({
          height: this.level ? `${minHeight + (this.level * (map[i] * diff))}px` : undefined
        })
      }
      return bars
    }
  }
}
</script>

<style scoped>
.assistent {
	background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
	background-size: 400% 400%;
	animation: gradient 15s ease infinite;
	padding: 30px;
  border-radius: 5px;
}
@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.assistent-photo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
  .assistent-photo img {
    max-width: 60%;
    border-radius: 50%;
  }
.assistent .bars {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  gap: 5px;
  height: 40px;
  margin: 0 auto;
}
  .assistent .bars > div {
    width: 15px;
    height: 15px;
    border-radius: 20px;
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.5);
    transition: transform 0.4s ease, height 0.4s ease, opacity 0.4s ease, background-color 0.4s ease;
  }
</style>
